import React, { Component, Ref } from 'react';
import Details1 from '../../../Assets/dataImages/details/details-1-image-1.png';
import Details2 from '../../../Assets/dataImages/details/details-1-image-2.png';
import Details3 from '../../../Assets/dataImages/details/details-1-image-3.png';
import Styles from './styles.module.css';
import ICarousel from '../../Abstraction/Carousel/ICarousel';
import ICarouselState from '../../Abstraction/Carousel/ICarouselState';
import Slider from "react-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import Slide from './Slide';
import VideoSlide from './VideoSlide';

export default class Carousel extends Component<ICarousel, ICarouselState>{
    private slider: any;

    constructor(props: any) {
        super(props);

        const width = window.innerWidth;

        this.state = {
            current: 0,
            windowWidth: width,
            showArrows: true
        }

        this.renderImages = this.renderImages.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    render() {
        const settings = {
            className: `slider variable-width ${Styles.slider}`,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            centerMode: true,
            variableWidth: true,
            onBeforeChange: null,
            onAfterChange: null,
            afterChange: (index: any) => { this.setState({ current: index, showArrows:true }) },
            arrows: false,
            accessibility: false,
            swipe: true,
            touchMove: true,
            touchThreshold: 5,
            draggable: true,
            vertical: false,
            focusOnSelect: false,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: false,
                  }
                }
            ]
        };
        return (
            <div>
                <div className={Styles.sliderLeftBlock}/>
                <div className={Styles.sliderRightBlock}/>
                <Slider ref={c => (this.slider = c)} {...settings}>
                    {this.props.isVideo ? this.renderVideos() : this.renderImages()}
                </Slider>
            </div>
        );
    }

    next() {
        this.slider.slickNext();
        this.setState({showArrows: false});
    }
    previous() {
        this.slider.slickPrev();
        this.setState({showArrows: false});
    }

    renderImages() {
        const content: any[] = [];
        this.props.images!.forEach((image: string, index: number) => {
            content.push(
                <Slide index={index} image={image} current={this.state.current} previous={this.previous} next={this.next} showArrows={this.state.showArrows} key={`slide-${index}`}/>
            )
        });

        return content;
    }

    renderVideos() {
        const content: any[] = [];
        this.props.videos!.forEach((video: string, index: number) => {
            content.push(
                <VideoSlide index={index} video={video} current={this.state.current} previous={this.previous} next={this.next} showArrows={this.state.showArrows} key={`slide-${index}`}/>
            )
        });

        return content;
    }
}